import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import apiClient from '../libs/apiClient';
import { useApplicationContext } from '../providers/ApplicationProvider';
import { ENV_LABEL, WebConfig } from '../types/auth';
import { ApiResponse } from '../types/response';

const getEnvironmentLabel = (mode: string | null) => {
  if (!mode) {
    return null; // Default case for null or undefined mode
  }

  return ENV_LABEL[mode.toLowerCase()] || null;
};

const useGetConfiguration = () => {
  const { setEnvironment } = useApplicationContext();

  return useQuery({
    queryKey: ['config'],
    queryFn: async () => {
      const { data: responseData } = await apiClient.get<ApiResponse<WebConfig>>('/cdus-ui/configuration');

      const data = responseData.data;
      if (data.env) {
        setEnvironment(getEnvironmentLabel(data.env));
      }

      return data;
    },

    retry: (failureCount, error) => {
      // Prevent retry on 503 status
      return !(error instanceof AxiosError && error.response?.status === 503) && failureCount < 3;
    },

    staleTime: Infinity,
  });
};

export default useGetConfiguration;
